import React from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface MomentControlProps {
  index: number;
  count: number;
  title: string;
  onPrev: () => void;
  onNext: () => void;
}
const screens = [{
  to: '/',
  label: 'Wand'
}, {
  to: '/bureau',
  label: 'Bureau'
}, {
  to: '/telefoon',
  label: 'Telefoon'
}, {
  to: '/spec',
  label: 'Spec'
}];

/** Demo control: click through the scenario and switch screens. Sits apart from the product UI. */
export function MomentControl({
  index,
  count,
  title,
  onPrev,
  onNext
}: MomentControlProps) {
  return <div className="absolute left-1/2 top-2 z-40 flex -translate-x-1/2 items-center gap-1 rounded-full border border-white/10 bg-night-900 p-0.5" data-id="element-1621" data-mp="3fnb0g5pl46by">
      <nav aria-label="Demo-schermen" className={`flex items-center ${count > 1 ? 'border-r border-white/10 pr-1' : ''}`} data-id="element-1622" data-mp="3bkwhzmptv8l7">
        {screens.map(s => <NavLink key={s.to} to={s.to} end className={({
        isActive
      }) => `whitespace-nowrap rounded-full px-3 py-2 text-[14px] font-medium transition-colors duration-150 ${isActive ? 'bg-white/[0.08] text-ink' : 'text-ink-muted hover:text-ink'}`} data-id="element-1623" data-mp="1h9ri8thv3gb5">
            {s.label}
          </NavLink>)}
      </nav>
      {count > 1 && <>
      <button type="button" onClick={onPrev} aria-label="Vorig moment" className="grid h-9 w-9 place-items-center rounded-full text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-1624" data-mp="1lzscbio8ct64">
        <ChevronLeftIcon className="h-5 w-5" data-id="element-1625" data-mp="1v06z6mguegbq" />
      </button>
      <span className="whitespace-nowrap px-1 text-[14px] tabular-nums text-ink-muted" data-id="element-1626" data-mp="1zzjnzcr9xxgy">
        {index + 1}/{count} · {title}
      </span>
      <button type="button" onClick={onNext} className="flex h-9 items-center gap-1 whitespace-nowrap rounded-full pl-2 pr-3 text-[14px] font-medium text-ink transition-colors duration-150 hover:text-accent" data-id="element-1627" data-mp="nh8seponp93">
        Volgende moment <ChevronRightIcon className="h-4 w-4" aria-hidden data-id="element-1628" data-mp="3ts1sv4cdf1k5" />
      </button>
      </>}
    </div>;
}